import React from 'react';
import { Breadcrumb, Layout, Row, Col } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import PaymentMethods from './PaymentMethods';
import Cart from '../Cart';
import ArrowNextIcon from '../../../asset/arrow-next.svg';
import InnerHeader from '../../../component/InnerHeader';

const CartPaymentMethod = () => {
  const location = useLocation();

  function itemRender(route) {
    const mainRoute = route.path === location.pathname;
    return mainRoute ? (
      <b>{route.breadcrumbName}</b>
    ) : (
      <Link to={route.path}>{route.breadcrumbName}</Link>
    );
  }

  const routes = [
    {
      breadcrumbName: 'Cart',
      path: '/cart'
    },
    {
      breadcrumbName: 'Payment Method',
      path: '/cart/payment-method'
    },
    {
      breadcrumbName: 'Overview',
      path: '/cart/payment-method/overview'
    }
  ];

  return (
    <Layout style={{ backgroundColor: 'white', display: 'flex' }}>
      <Breadcrumb
        itemRender={itemRender}
        routes={routes}
        separator={<img alt="separator icon" src={ArrowNextIcon} />}
        style={{
          background: 'white',
          display: 'flex',
          fontSize: '12px',
          justifyContent: 'flex-start',
          padding: '40px 0px 34px 35px'
        }}
      />

      <InnerHeader title="Select a Payment Method" />

      <Row>
        <Col>
          <PaymentMethods />
        </Col>
        <Col>
          <Cart style={{ height: '300px' }} />
        </Col>
      </Row>
    </Layout>
  );
};

export default CartPaymentMethod;
